export interface GenericModalOptions {
  header: string;
  message: string;
  type?: GenericModalType;
}

export enum GenericModalType {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}
